import { render, staticRenderFns } from "./RaporDetayView.vue?vue&type=template&id=38e6b814"
import script from "./RaporDetayView.vue?vue&type=script&lang=ts"
export * from "./RaporDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports